import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 8h4l-2 8","key":"svg-0"}],["path",{"d":"M10 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3","key":"svg-1"}]]

const IconNumber67Small = createReactComponent('outline', 'number-67-small', 'Number67Small', __iconNode);

export default IconNumber67Small;